import client from "./client";

export function getDoctors() {
  return client.get("/api/doctors/").then((res) => res.data);
}

export function getDoctorsWithSchedules(
  monday,
  tuesday,
  wednesday,
  thursday,
  friday,
  saturday,
  sunday,
) {
  return client
    .get("/api/doctors/schedules/weekly/", {
      params: {
        monday: monday,
        tuesday: tuesday,
        wednesday: wednesday,
        thursday: thursday,
        friday: friday,
        saturday: saturday,
        sunday: sunday,
      },
    })
    .then((res) => res.data);
}

export function getDoctorSummary() {
  return client.get("/api/doctor_summary/").then((res) => res.data);
}

export function getDoctor(id) {
  return client.get(`/api/doctors/${id}/`).then((res) => res.data);
}

export function addDoctor(body) {
  return client.post("/api/doctors/", body).then((res) => res.data);
}

export function setDoctor(body) {
  return client.put(`/api/doctors/${body.id}/`, body).then((res) => res.data);
}

export function deleteDoctor(body) {
  return client.delete(`/api/doctors/${body.id}/`).then((res) => res.data);
}
